module.exports = __webpack_public_path__ + "bc5c9e3eff2de3f88b03ded3278f76ec.png";